import React, { useState } from 'react';

import {
  MenuLabel,
  Icon,
  NavBackground,
  Navigation,
  List,
  ItemLink,
} from './styles';

function HamburgerMenu() {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const scrollTop = () => {
    setClick(!click);

    window.scrollTo({
      top: 0,
    });
  };

  return (
    <>
      <MenuLabel htmlFor='navi-toggle' onClick={handleClick}>
        <Icon clicked={click}>&nbsp;</Icon>
      </MenuLabel>
      <NavBackground clicked={click}>&nbsp;</NavBackground>

      <Navigation clicked={click}>
        <List>
          <li>
            <ItemLink onClick={scrollTop}>Home</ItemLink>
          </li>
          <li>
            <ItemLink onClick={handleClick} href='#about'>
              About
            </ItemLink>
          </li>
          <li>
            <ItemLink onClick={handleClick} href='#projects'>
              Projects
            </ItemLink>
          </li>
          <li>
            <ItemLink onClick={handleClick} href='#contact'>
              Contact
            </ItemLink>
          </li>
        </List>
      </Navigation>
    </>
  );
}

export default HamburgerMenu;
